import React from "react";

interface ActionButtonProps {
  onClick: () => void;
  label: string;
  variant?: "primary" | "secondary" | "success" | "danger";
  className?: string;
  disabled?: boolean;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  label,
  variant = "primary",
  className = "",
  disabled = false,
}) => {
  const baseClasses = "px-4 py-2 text-white rounded hover:opacity-90";
  const variantClasses = {
    primary: "bg-blue-500 hover:bg-blue-600",
    secondary: "bg-gray-500 hover:bg-gray-600",
    success: "bg-green-600 hover:bg-green-700",
    danger: "bg-red-500 hover:bg-red-600",
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${className}`}
    >
      {label}
    </button>
  );
};
